import { axiosInstance } from "../../lib/axios";

import type { AgencyWorkspacesResponse, WorkspacesResponse } from "../types";

export const workspaceService = {
  async getWorkspaces(): Promise<WorkspacesResponse> {
    const response =
      await axiosInstance.get<WorkspacesResponse>("/user/workspaces");
    return response.data;
  },

  async getAgencyWorkspaces(): Promise<AgencyWorkspacesResponse> {
    const response = await axiosInstance.get<AgencyWorkspacesResponse>(
      "/user/agency-workspaces",
    );
    return response.data;
  },
};
